import React from "react"
import styled from "styled-components"
import { useGetTrainingAndVideo } from "../hooks/useGetTrainingAndVideo"
import { useControlVideo } from "../hooks/useControlVideo"
import { useFinishSound } from "../hooks/useFinishSound"
import Image from "../Component/Image"
import SoundPlayer from "../Component/SoundPlayer"
import VideoSwiper from "../Component/VideoSwiper"
import { SampleTraining, VideoUrls } from "../Interface"
import { color, font } from "../Util/theme"
import Config from "../Config/index"

const { ImageFile } = Config

const SoundContainer = ({ location }) => {
  const { training, videoUrls } = useGetTrainingAndVideo({ location })
  const { playing, showVideo, closeVideo } = useControlVideo()
  const { onFinishSound } = useFinishSound()
  return (
    <SoundPage
      training={training}
      videoUrls={videoUrls}
      playing={playing}
      onFinishSound={onFinishSound}
      showVideo={showVideo}
      closeVideo={closeVideo}
    />
  )
}

interface SoundPageProps {
  training: SampleTraining
  videoUrls: VideoUrls
  playing: boolean
  showVideo: () => void
  closeVideo: () => void
  onFinishSound: () => void
}

const SoundPage: React.FC<SoundPageProps> = ({
  training,
  videoUrls,
  playing,
  showVideo,
  closeVideo,
  onFinishSound,
}) => {
  return (
    <>
      <Root>
        <BgImage src={training.background_img} />
      </Root>
      <Root>
        <UpperContainer>
          <Header>
            <TrainerContainer>
              <TrainerIcon src={training.trainer_icon} />
              <TrainerName>{training.trainer_name}</TrainerName>
            </TrainerContainer>
            <ExitButton onClick={onFinishSound}>
              <Image filename={ImageFile.Stop} />
            </ExitButton>
          </Header>
          <TitleNameContainer>
            <ContentTitle>{training.name}</ContentTitle>
          </TitleNameContainer>
        </UpperContainer>
        <MiddleContainer>
          {training.video_count && !playing && (
            <VideoButtonContainer>
              <CheckVideoContainer onClick={showVideo}>
                <Image filename={ImageFile.CheckVideo} />
              </CheckVideoContainer>
            </VideoButtonContainer>
          )}
          {playing && (
            <VideoContainer>
              <VideoSwiper
                videoUrls={videoUrls}
                onClick={closeVideo}
                height="300px"
                isBottomText
              />
            </VideoContainer>
          )}
        </MiddleContainer>
        <LowerContainer>
          <InformationTextContainer>
            <Information>再生が開始されない場合は</Information>
            <Information>▶︎マークをタップしてください。</Information>
          </InformationTextContainer>
          <Player>
            <SoundPlayer url={training.contents} />
          </Player>
        </LowerContainer>
      </Root>
    </>
  )
}

const Root = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: -1;
`
const BgImage = styled.img`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0px;
  object-fit: cover;
`
const UpperContainer = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 130px;
  width: 100%;
  z-index: -1;
`
const Header = styled.div`
  margin-top: 52px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  background-color: transparent;
`
const TrainerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;
  padding-left: 15px;
`
const TrainerIcon = styled.img`
  width: 53px;
  height: 53px;
  border-radius: 26.5px;
  margin-right: 8px;
  opacity: 0.9;
`
const TitleNameContainer = styled.div`
  margin-top: 19px;
  padding-left: 15px;
`
const TrainerName = styled.div`
  font-size: 18px;
  color: ${color.black};
  font-weight: 600;
  font-family: ${font.W3};
`
const ExitButton = styled.div`
  width: 102px;
  height: 40px;
  margin-right: 25px;
  margin-top: 7.5px;
  z-index: 2;
`
const ContentTitle = styled.div`
  font-size: 18px;
  color: ${color.black};
  font-family: ${font.W6};
`
const MiddleContainer = styled.div`
  position: absolute;
  top: 130px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 187px;
  width: 100%;
  z-index: 1;
`
const VideoButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 200px;
  z-index: 2;
`
const CheckVideoContainer = styled.div`
  width: 182px;
  height: 50px;
`
const VideoContainer = styled.div`
  position: absolute;
  top: -10px;
  left: 0px;
  right: 0px;
  z-index: 2;
`
const LowerContainer = styled.div`
  position: fixed;
  top: 400px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 500px;
  width: 100%;
  opacity: 0.7;
  background-color: ${color.black};
`
const InformationTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`
const Information = styled.div`
  font-size: 18px;
  color: ${color.white};
  font-family: ${font.W6};
`
const Player = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -80px;
`

export default SoundContainer
